import 'can-construct-super';
import PlayerBase from "@/js/controllers/player/base.js";
import Rutube from "@/js/lib/rt.js";


/**
 * Плеер Rutube
 **/

const PlayerRutube = PlayerBase.extend(
    {
        defaults: {}
    },
    {
        async init() {
            this.rt = new Rutube();
            await this.rt.Player(this.element.getAttribute('id'), {
                width: '100%',
                height: 300,
                videoId: this.element.getAttribute('js-player-rutube'),
                "events": {
                    "onReady": this.onPlayerReady,
                    "onStateChange": this.onPlayerStateChange
                }
            });
        },
        onPlayerReady(event) {
            console.log('Плеер загружен.');

        },
        onPlayerStateChange(event) {
            console.log(event);
        }
    }
);

export default PlayerRutube;